// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2rFmp","addWidgetButton":"Header_addWidgetButton__oeJfV","dashboardTabs":"Header_dashboardTabs__ARSQw","active":"Header_active__1gfAb"};